import { useNavigate, useLocation } from "react-router-dom";
import { CraneMark } from "@/components/CraneMark";
import { Editable } from "@/components/Editable";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { useContent } from "@/contexts/ContentContext";
import { useAuth } from "@/contexts/AuthContext";
import { CMS } from "@/constants/testIds/cms";

export function Header({ onAdminClick }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { content } = useContent();
  const { admin } = useAuth();

  function scrollToId(id) {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 80);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  }

  if (!content) return null;

  const resources = content.resources || [];

  return (
    <header>
      <div className="wrap nav-inner">
        <a className="brand" onClick={() => navigate("/")} data-testid={CMS.navHome}>
          <CraneMark viewBox="150 60 170 120" />
          <span className="brand-text">
            <span className="brand-name">
              Elegant <em>Crane</em> Health
            </span>
            <span className="brand-tag">Holistic Health Consulting</span>
          </span>
        </a>
        <nav>
          <ul>
            <li>
              <a onClick={() => navigate("/")} data-testid={CMS.navHome}>
                <Editable path="nav.home" />
              </a>
            </li>
            <li>
              <a onClick={() => scrollToId("modalities")} data-testid={CMS.navPractices}>
                <Editable path="nav.practices" />
              </a>
            </li>
            <li>
              <a onClick={() => navigate("/videos")} data-testid={CMS.navVideos}>
                <Editable path="nav.videos" />
              </a>
            </li>
            <li>
              <a onClick={() => scrollToId("about")} data-testid={CMS.navAbout}>
                <Editable path="nav.about" />
              </a>
            </li>
            <li className="nav-resources-item">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <a data-testid={CMS.navResources}>
                    <Editable path="nav.resources" />
                  </a>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="resources-dropdown-content" align="start">
                  {resources.length === 0 && <DropdownMenuItem disabled>No resources yet</DropdownMenuItem>}
                  {resources.map((r, i) => (
                    <DropdownMenuItem key={i} asChild>
                      <a href={r.url || "#"} target="_blank" rel="noopener noreferrer" data-testid={`${CMS.resourceLink}-${i}`}>
                        {r.label}
                      </a>
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
            </li>
            <li>
              <a href={content.link} target="_blank" rel="noopener noreferrer" className="nav-cta" data-testid={CMS.navBook}>
                <Editable path="nav.book" />
              </a>
            </li>
            <li>
              <a className="nav-admin" onClick={onAdminClick} data-testid={CMS.navAdmin}>
                {admin ? "Admin panel" : "Admin"}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
